export default [
  {
    id: 404741057,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDQ3NDEwNTc=",
    name: "accordion",
    full_name: "AlmogWer/accordion",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/accordion",
    description: "HTML CSS & React - Q&A Component",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/accordion",
    forks_url: "https://api.github.com/repos/AlmogWer/accordion/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/accordion/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/accordion/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/accordion/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/accordion/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/accordion/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/accordion/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/accordion/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/accordion/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/accordion/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/accordion/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/accordion/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/accordion/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/accordion/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/accordion/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/accordion/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/accordion/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/accordion/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/accordion/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/accordion/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/accordion/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/accordion/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/accordion/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/accordion/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/accordion/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/accordion/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/accordion/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/accordion/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/accordion/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/accordion/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/accordion/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/accordion/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/accordion/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/accordion/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/accordion/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/accordion/deployments",
    created_at: "2021-09-09T13:52:43Z",
    updated_at: "2021-09-09T14:19:44Z",
    pushed_at: "2021-09-09T14:19:41Z",
    git_url: "git://github.com/AlmogWer/accordion.git",
    ssh_url: "git@github.com:AlmogWer/accordion.git",
    clone_url: "https://github.com/AlmogWer/accordion.git",
    svn_url: "https://github.com/AlmogWer/accordion",
    homepage: "https://almogwer-accordion.netlify.app/",
    size: 274,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 398833163,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTg4MzMxNjM=",
    name: "almogwerfood",
    full_name: "AlmogWer/almogwerfood",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/almogwerfood",
    description: "HTML & CSS one pager website",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/almogwerfood",
    forks_url: "https://api.github.com/repos/AlmogWer/almogwerfood/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/almogwerfood/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/almogwerfood/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/almogwerfood/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/almogwerfood/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/almogwerfood/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/almogwerfood/deployments",
    created_at: "2021-08-22T15:26:46Z",
    updated_at: "2021-08-23T08:42:05Z",
    pushed_at: "2021-08-23T08:42:02Z",
    git_url: "git://github.com/AlmogWer/almogwerfood.git",
    ssh_url: "git@github.com:AlmogWer/almogwerfood.git",
    clone_url: "https://github.com/AlmogWer/almogwerfood.git",
    svn_url: "https://github.com/AlmogWer/almogwerfood",
    homepage: "https://almogwer.github.io/almogwerfood/",
    size: 7612,
    stargazers_count: 3,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 4,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 4,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 403254345,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDMyNTQzNDU=",
    name: "birthday-reminder",
    full_name: "AlmogWer/birthday-reminder",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/birthday-reminder",
    description: "HTML CSS & React - simple birthday reminder using useState",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/birthday-reminder",
    forks_url: "https://api.github.com/repos/AlmogWer/birthday-reminder/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/birthday-reminder/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/birthday-reminder/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/birthday-reminder/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/birthday-reminder/deployments",
    created_at: "2021-09-05T08:26:03Z",
    updated_at: "2021-09-05T09:12:39Z",
    pushed_at: "2021-09-05T09:12:36Z",
    git_url: "git://github.com/AlmogWer/birthday-reminder.git",
    ssh_url: "git@github.com:AlmogWer/birthday-reminder.git",
    clone_url: "https://github.com/AlmogWer/birthday-reminder.git",
    svn_url: "https://github.com/AlmogWer/birthday-reminder",
    homepage: "https://almogwer-birthday-reminder.netlify.app",
    size: 333,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 401682353,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDE2ODIzNTM=",
    name: "brick-game",
    full_name: "AlmogWer/brick-game",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/brick-game",
    description:
      "HTML CSS & JS- traditional brick game using HTML5 canvas element and API",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/brick-game",
    forks_url: "https://api.github.com/repos/AlmogWer/brick-game/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/brick-game/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/brick-game/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/brick-game/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/brick-game/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/brick-game/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/brick-game/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/brick-game/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/brick-game/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/brick-game/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/brick-game/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/brick-game/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/brick-game/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/brick-game/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/brick-game/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/brick-game/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/brick-game/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/brick-game/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/brick-game/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/brick-game/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/brick-game/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/brick-game/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/brick-game/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/brick-game/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/brick-game/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/brick-game/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/brick-game/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/brick-game/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/brick-game/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/brick-game/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/brick-game/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/brick-game/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/brick-game/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/brick-game/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/brick-game/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/brick-game/deployments",
    created_at: "2021-08-31T11:44:34Z",
    updated_at: "2021-09-01T06:41:42Z",
    pushed_at: "2021-08-31T13:32:48Z",
    git_url: "git://github.com/AlmogWer/brick-game.git",
    ssh_url: "git@github.com:AlmogWer/brick-game.git",
    clone_url: "https://github.com/AlmogWer/brick-game.git",
    svn_url: "https://github.com/AlmogWer/brick-game",
    homepage: "https://almogwer.github.io/brick-game/",
    size: 29,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 406405407,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDY0MDU0MDc=",
    name: "cart",
    full_name: "AlmogWer/cart",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/cart",
    description: "HTML CSS & React - Cart component ",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/cart",
    forks_url: "https://api.github.com/repos/AlmogWer/cart/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/cart/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/cart/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/cart/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/cart/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/cart/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/cart/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/cart/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/cart/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/cart/tags",
    blobs_url: "https://api.github.com/repos/AlmogWer/cart/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/AlmogWer/cart/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/AlmogWer/cart/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/AlmogWer/cart/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/AlmogWer/cart/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/cart/languages",
    stargazers_url: "https://api.github.com/repos/AlmogWer/cart/stargazers",
    contributors_url: "https://api.github.com/repos/AlmogWer/cart/contributors",
    subscribers_url: "https://api.github.com/repos/AlmogWer/cart/subscribers",
    subscription_url: "https://api.github.com/repos/AlmogWer/cart/subscription",
    commits_url: "https://api.github.com/repos/AlmogWer/cart/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/cart/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/cart/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/cart/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/AlmogWer/cart/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/cart/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/cart/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/cart/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/cart/downloads",
    issues_url: "https://api.github.com/repos/AlmogWer/cart/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/cart/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/cart/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/cart/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/cart/labels{/name}",
    releases_url: "https://api.github.com/repos/AlmogWer/cart/releases{/id}",
    deployments_url: "https://api.github.com/repos/AlmogWer/cart/deployments",
    created_at: "2021-09-14T14:40:50Z",
    updated_at: "2021-09-14T16:12:34Z",
    pushed_at: "2021-09-14T16:12:31Z",
    git_url: "git://github.com/AlmogWer/cart.git",
    ssh_url: "git@github.com:AlmogWer/cart.git",
    clone_url: "https://github.com/AlmogWer/cart.git",
    svn_url: "https://github.com/AlmogWer/cart",
    homepage: "https://almogwer-cart.netlify.app/",
    size: 402,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 406727822,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDY3Mjc4MjI=",
    name: "cocktail-generator",
    full_name: "AlmogWer/cocktail-generator",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/cocktail-generator",
    description:
      "HTML CSS & React - Cocktail generator site (fetching from API) with routes to display multiple pages and single ID selection",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/cocktail-generator",
    forks_url: "https://api.github.com/repos/AlmogWer/cocktail-generator/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/cocktail-generator/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/cocktail-generator/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/cocktail-generator/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/cocktail-generator/deployments",
    created_at: "2021-09-15T11:06:41Z",
    updated_at: "2021-09-15T16:29:31Z",
    pushed_at: "2021-09-15T13:16:26Z",
    git_url: "git://github.com/AlmogWer/cocktail-generator.git",
    ssh_url: "git@github.com:AlmogWer/cocktail-generator.git",
    clone_url: "https://github.com/AlmogWer/cocktail-generator.git",
    svn_url: "https://github.com/AlmogWer/cocktail-generator",
    homepage: "https://almogwer-cocktail-generator.netlify.app/",
    size: 1026,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 405907118,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDU5MDcxMTg=",
    name: "color-generator",
    full_name: "AlmogWer/color-generator",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/color-generator",
    description: "HTML CSS & React - Color generator with click-to-copy",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/color-generator",
    forks_url: "https://api.github.com/repos/AlmogWer/color-generator/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/color-generator/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/color-generator/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/color-generator/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/color-generator/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/color-generator/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/color-generator/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/color-generator/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/color-generator/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/color-generator/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/color-generator/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/color-generator/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/color-generator/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/color-generator/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/color-generator/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/color-generator/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/color-generator/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/color-generator/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/color-generator/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/color-generator/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/color-generator/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/color-generator/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/color-generator/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/color-generator/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/color-generator/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/color-generator/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/color-generator/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/color-generator/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/color-generator/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/color-generator/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/color-generator/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/color-generator/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/color-generator/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/color-generator/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/color-generator/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/color-generator/deployments",
    created_at: "2021-09-13T09:17:06Z",
    updated_at: "2021-09-13T11:25:07Z",
    pushed_at: "2021-09-13T11:25:05Z",
    git_url: "git://github.com/AlmogWer/color-generator.git",
    ssh_url: "git@github.com:AlmogWer/color-generator.git",
    clone_url: "https://github.com/AlmogWer/color-generator.git",
    svn_url: "https://github.com/AlmogWer/color-generator",
    homepage: "https://almogwer-color-generator.netlify.app/",
    size: 203,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 400083663,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDAwODM2NjM=",
    name: "custom-music-player",
    full_name: "AlmogWer/custom-music-player",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/custom-music-player",
    description:
      "HTML CSS & JS - Custom music player with animation using HTML5 audio API",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/custom-music-player",
    forks_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/teams",
    hooks_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/custom-music-player/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/custom-music-player/deployments",
    created_at: "2021-08-26T07:42:04Z",
    updated_at: "2021-09-01T06:38:36Z",
    pushed_at: "2021-08-26T08:51:48Z",
    git_url: "git://github.com/AlmogWer/custom-music-player.git",
    ssh_url: "git@github.com:AlmogWer/custom-music-player.git",
    clone_url: "https://github.com/AlmogWer/custom-music-player.git",
    svn_url: "https://github.com/AlmogWer/custom-music-player",
    homepage: "https://almogwer.github.io/custom-music-player/",
    size: 9727,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 399382204,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTkzODIyMDQ=",
    name: "custom-video-player",
    full_name: "AlmogWer/custom-video-player",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/custom-video-player",
    description:
      "HTML CSS & JS - custom video player using HTML5 functionality",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/custom-video-player",
    forks_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/teams",
    hooks_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/custom-video-player/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/custom-video-player/deployments",
    created_at: "2021-08-24T07:57:55Z",
    updated_at: "2021-09-01T06:36:13Z",
    pushed_at: "2021-08-24T08:58:09Z",
    git_url: "git://github.com/AlmogWer/custom-video-player.git",
    ssh_url: "git@github.com:AlmogWer/custom-video-player.git",
    clone_url: "https://github.com/AlmogWer/custom-video-player.git",
    svn_url: "https://github.com/AlmogWer/custom-video-player",
    homepage: "https://almogwer.github.io/custom-video-player/",
    size: 17829,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 407197546,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDcxOTc1NDY=",
    name: "dark-mode",
    full_name: "AlmogWer/dark-mode",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/dark-mode",
    description: "HTML CSS & React - Dark mode toggle",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/dark-mode",
    forks_url: "https://api.github.com/repos/AlmogWer/dark-mode/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/dark-mode/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/dark-mode/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/dark-mode/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/dark-mode/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/dark-mode/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/dark-mode/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/dark-mode/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/dark-mode/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/dark-mode/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/dark-mode/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/dark-mode/deployments",
    created_at: "2021-09-16T14:31:30Z",
    updated_at: "2021-09-16T16:22:35Z",
    pushed_at: "2021-09-16T16:22:33Z",
    git_url: "git://github.com/AlmogWer/dark-mode.git",
    ssh_url: "git@github.com:AlmogWer/dark-mode.git",
    clone_url: "https://github.com/AlmogWer/dark-mode.git",
    svn_url: "https://github.com/AlmogWer/dark-mode",
    homepage: "https://almogwer-darkmode.netlify.app/",
    size: 458,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 395661673,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTU2NjE2NzM=",
    name: "Dice-game",
    full_name: "AlmogWer/Dice-game",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/Dice-game",
    description: "Pure Vanilla JS",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/Dice-game",
    forks_url: "https://api.github.com/repos/AlmogWer/Dice-game/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/Dice-game/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/Dice-game/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/Dice-game/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/Dice-game/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/Dice-game/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/Dice-game/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/Dice-game/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/Dice-game/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/Dice-game/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/Dice-game/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/Dice-game/deployments",
    created_at: "2021-08-13T13:17:33Z",
    updated_at: "2021-08-13T13:33:32Z",
    pushed_at: "2021-08-13T13:33:30Z",
    git_url: "git://github.com/AlmogWer/Dice-game.git",
    ssh_url: "git@github.com:AlmogWer/Dice-game.git",
    clone_url: "https://github.com/AlmogWer/Dice-game.git",
    svn_url: "https://github.com/AlmogWer/Dice-game",
    homepage: "https://almogwer.github.io/Dice-game/",
    size: 24,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 399474116,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTk0NzQxMTY=",
    name: "DOM-array-methods",
    full_name: "AlmogWer/DOM-array-methods",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/DOM-array-methods",
    description:
      "HTML CSS & JS - Fetch random users and manipulating their data using high order array methods",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/DOM-array-methods",
    forks_url: "https://api.github.com/repos/AlmogWer/DOM-array-methods/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/DOM-array-methods/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/DOM-array-methods/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/DOM-array-methods/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/DOM-array-methods/deployments",
    created_at: "2021-08-24T13:23:39Z",
    updated_at: "2021-09-01T06:37:07Z",
    pushed_at: "2021-08-24T14:55:32Z",
    git_url: "git://github.com/AlmogWer/DOM-array-methods.git",
    ssh_url: "git@github.com:AlmogWer/DOM-array-methods.git",
    clone_url: "https://github.com/AlmogWer/DOM-array-methods.git",
    svn_url: "https://github.com/AlmogWer/DOM-array-methods",
    homepage: "https://almogwer.github.io/DOM-array-methods/",
    size: 95,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 399413420,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTk0MTM0MjA=",
    name: "exchange-rate-calculator",
    full_name: "AlmogWer/exchange-rate-calculator",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/exchange-rate-calculator",
    description:
      "HTML CSS & JS - simple exchange rate calculator using fetch exchange rates from API",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/exchange-rate-calculator",
    forks_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/teams",
    hooks_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/exchange-rate-calculator/deployments",
    created_at: "2021-08-24T09:49:01Z",
    updated_at: "2021-09-01T06:36:39Z",
    pushed_at: "2021-08-24T12:20:47Z",
    git_url: "git://github.com/AlmogWer/exchange-rate-calculator.git",
    ssh_url: "git@github.com:AlmogWer/exchange-rate-calculator.git",
    clone_url: "https://github.com/AlmogWer/exchange-rate-calculator.git",
    svn_url: "https://github.com/AlmogWer/exchange-rate-calculator",
    homepage: "https://almogwer.github.io/exchange-rate-calculator/",
    size: 139,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 399833973,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTk4MzM5NzM=",
    name: "expense-tracker",
    full_name: "AlmogWer/expense-tracker",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/expense-tracker",
    description:
      "HTML CSS & JS - Expense tracker using high array methods and local storage",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/expense-tracker",
    forks_url: "https://api.github.com/repos/AlmogWer/expense-tracker/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/expense-tracker/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/expense-tracker/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/expense-tracker/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/expense-tracker/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/expense-tracker/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/expense-tracker/deployments",
    created_at: "2021-08-25T13:43:48Z",
    updated_at: "2021-09-01T06:38:19Z",
    pushed_at: "2021-08-25T15:47:47Z",
    git_url: "git://github.com/AlmogWer/expense-tracker.git",
    ssh_url: "git@github.com:AlmogWer/expense-tracker.git",
    clone_url: "https://github.com/AlmogWer/expense-tracker.git",
    svn_url: "https://github.com/AlmogWer/expense-tracker",
    homepage: "https://almogwer.github.io/expense-tracker/",
    size: 59,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 399040723,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTkwNDA3MjM=",
    name: "form-validator",
    full_name: "AlmogWer/form-validator",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/form-validator",
    description: "HTML CSS & JS- Form validator",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/form-validator",
    forks_url: "https://api.github.com/repos/AlmogWer/form-validator/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/form-validator/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/form-validator/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/form-validator/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/form-validator/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/form-validator/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/form-validator/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/form-validator/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/form-validator/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/form-validator/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/form-validator/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/form-validator/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/form-validator/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/form-validator/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/form-validator/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/form-validator/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/form-validator/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/form-validator/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/form-validator/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/form-validator/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/form-validator/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/form-validator/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/form-validator/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/form-validator/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/form-validator/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/form-validator/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/form-validator/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/form-validator/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/form-validator/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/form-validator/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/form-validator/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/form-validator/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/form-validator/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/form-validator/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/form-validator/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/form-validator/deployments",
    created_at: "2021-08-23T09:12:48Z",
    updated_at: "2021-09-01T06:35:10Z",
    pushed_at: "2021-08-23T14:12:02Z",
    git_url: "git://github.com/AlmogWer/form-validator.git",
    ssh_url: "git@github.com:AlmogWer/form-validator.git",
    clone_url: "https://github.com/AlmogWer/form-validator.git",
    svn_url: "https://github.com/AlmogWer/form-validator",
    homepage: "https://almogwer.github.io/form-validator/",
    size: 17,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 408155325,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDgxNTUzMjU=",
    name: "github-user-dashboard",
    full_name: "AlmogWer/github-user-dashboard",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/github-user-dashboard",
    description: null,
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/github-user-dashboard",
    forks_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/teams",
    hooks_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/github-user-dashboard/deployments",
    created_at: "2021-09-19T14:53:47Z",
    updated_at: "2021-09-19T15:29:10Z",
    pushed_at: "2021-09-19T15:29:08Z",
    git_url: "git://github.com/AlmogWer/github-user-dashboard.git",
    ssh_url: "git@github.com:AlmogWer/github-user-dashboard.git",
    clone_url: "https://github.com/AlmogWer/github-user-dashboard.git",
    svn_url: "https://github.com/AlmogWer/github-user-dashboard",
    homepage: null,
    size: 0,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 405950630,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDU5NTA2MzA=",
    name: "grocery-list",
    full_name: "AlmogWer/grocery-list",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/grocery-list",
    description: "HTML CSS & React - Grocery list stored on local storage",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/grocery-list",
    forks_url: "https://api.github.com/repos/AlmogWer/grocery-list/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/grocery-list/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/grocery-list/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/grocery-list/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/grocery-list/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/grocery-list/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/grocery-list/deployments",
    created_at: "2021-09-13T11:46:36Z",
    updated_at: "2021-09-13T13:16:56Z",
    pushed_at: "2021-09-13T13:16:53Z",
    git_url: "git://github.com/AlmogWer/grocery-list.git",
    ssh_url: "git@github.com:AlmogWer/grocery-list.git",
    clone_url: "https://github.com/AlmogWer/grocery-list.git",
    svn_url: "https://github.com/AlmogWer/grocery-list",
    homepage: "https://almogwer-grocery-list.netlify.app/",
    size: 772,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 395606375,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTU2MDYzNzU=",
    name: "Guess-my-number",
    full_name: "AlmogWer/Guess-my-number",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/Guess-my-number",
    description: "Pure vanilla JS",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/Guess-my-number",
    forks_url: "https://api.github.com/repos/AlmogWer/Guess-my-number/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/Guess-my-number/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/Guess-my-number/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/Guess-my-number/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/Guess-my-number/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/Guess-my-number/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/Guess-my-number/deployments",
    created_at: "2021-08-13T10:08:54Z",
    updated_at: "2021-08-13T13:38:58Z",
    pushed_at: "2021-08-13T13:38:55Z",
    git_url: "git://github.com/AlmogWer/Guess-my-number.git",
    ssh_url: "git@github.com:AlmogWer/Guess-my-number.git",
    clone_url: "https://github.com/AlmogWer/Guess-my-number.git",
    svn_url: "https://github.com/AlmogWer/Guess-my-number",
    homepage: "https://almogwer.github.io/guess-my-number/",
    size: 4,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 407532082,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDc1MzIwODI=",
    name: "hacker-news",
    full_name: "AlmogWer/hacker-news",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/hacker-news",
    description: "HTML CSS & React - Fetch stories from API",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/hacker-news",
    forks_url: "https://api.github.com/repos/AlmogWer/hacker-news/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/hacker-news/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/hacker-news/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/hacker-news/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/hacker-news/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/hacker-news/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/hacker-news/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/hacker-news/deployments",
    created_at: "2021-09-17T12:27:19Z",
    updated_at: "2021-09-17T13:46:35Z",
    pushed_at: "2021-09-17T13:46:33Z",
    git_url: "git://github.com/AlmogWer/hacker-news.git",
    ssh_url: "git@github.com:AlmogWer/hacker-news.git",
    clone_url: "https://github.com/AlmogWer/hacker-news.git",
    svn_url: "https://github.com/AlmogWer/hacker-news",
    homepage: "https://almogwer-hackernews.netlify.app/",
    size: 486,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 400110516,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDAxMTA1MTY=",
    name: "infinite-scroll-posts",
    full_name: "AlmogWer/infinite-scroll-posts",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/infinite-scroll-posts",
    description:
      "HTML CSS & JS -Infinite scroll using fetch posts API and a filter method to show relevant posts",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/infinite-scroll-posts",
    forks_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/teams",
    hooks_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/infinite-scroll-posts/deployments",
    created_at: "2021-08-26T09:19:38Z",
    updated_at: "2021-09-01T06:39:01Z",
    pushed_at: "2021-08-26T09:56:21Z",
    git_url: "git://github.com/AlmogWer/infinite-scroll-posts.git",
    ssh_url: "git@github.com:AlmogWer/infinite-scroll-posts.git",
    clone_url: "https://github.com/AlmogWer/infinite-scroll-posts.git",
    svn_url: "https://github.com/AlmogWer/infinite-scroll-posts",
    homepage: "https://almogwer.github.io/infinite-scroll-posts/",
    size: 229,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 405875915,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDU4NzU5MTU=",
    name: "lorem-ipsum-generator-hebrew",
    full_name: "AlmogWer/lorem-ipsum-generator-hebrew",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/lorem-ipsum-generator-hebrew",
    description: "HTML CSS & React - Lorem Ipsum Generator",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew",
    forks_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/collaborators{/collaborator}",
    teams_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/teams",
    hooks_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/branches{/branch}",
    tags_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/lorem-ipsum-generator-hebrew/deployments",
    created_at: "2021-09-13T07:31:56Z",
    updated_at: "2021-09-13T08:46:44Z",
    pushed_at: "2021-09-13T08:46:41Z",
    git_url: "git://github.com/AlmogWer/lorem-ipsum-generator-hebrew.git",
    ssh_url: "git@github.com:AlmogWer/lorem-ipsum-generator-hebrew.git",
    clone_url: "https://github.com/AlmogWer/lorem-ipsum-generator-hebrew.git",
    svn_url: "https://github.com/AlmogWer/lorem-ipsum-generator-hebrew",
    homepage: "https://almogwer-lorem-ipsum-generator.netlify.app/",
    size: 246,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 406833921,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDY4MzM5MjE=",
    name: "Markdown",
    full_name: "AlmogWer/Markdown",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/Markdown",
    description: "HTML CSS & React - Simple Markdown component",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/Markdown",
    forks_url: "https://api.github.com/repos/AlmogWer/Markdown/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/Markdown/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/Markdown/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/Markdown/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/Markdown/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/Markdown/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/Markdown/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/Markdown/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/Markdown/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/Markdown/tags",
    blobs_url: "https://api.github.com/repos/AlmogWer/Markdown/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/Markdown/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/Markdown/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/AlmogWer/Markdown/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/Markdown/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/Markdown/languages",
    stargazers_url: "https://api.github.com/repos/AlmogWer/Markdown/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/Markdown/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/Markdown/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/Markdown/subscription",
    commits_url: "https://api.github.com/repos/AlmogWer/Markdown/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/Markdown/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/Markdown/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/Markdown/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/Markdown/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/Markdown/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/Markdown/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/Markdown/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/Markdown/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/Markdown/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/Markdown/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/Markdown/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/Markdown/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/Markdown/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/Markdown/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/Markdown/deployments",
    created_at: "2021-09-15T15:54:19Z",
    updated_at: "2021-09-15T16:25:13Z",
    pushed_at: "2021-09-15T16:25:09Z",
    git_url: "git://github.com/AlmogWer/Markdown.git",
    ssh_url: "git@github.com:AlmogWer/Markdown.git",
    clone_url: "https://github.com/AlmogWer/Markdown.git",
    svn_url: "https://github.com/AlmogWer/Markdown",
    homepage: "https://almogwer-markdown.netlify.app/",
    size: 1277,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 399797771,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTk3OTc3NzE=",
    name: "meal-finder",
    full_name: "AlmogWer/meal-finder",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/meal-finder",
    description:
      "HTML CSS & JS - fetch meal from API based on search/random generate",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/meal-finder",
    forks_url: "https://api.github.com/repos/AlmogWer/meal-finder/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/meal-finder/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/meal-finder/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/meal-finder/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/meal-finder/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/meal-finder/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/meal-finder/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/meal-finder/deployments",
    created_at: "2021-08-25T11:43:59Z",
    updated_at: "2021-09-01T06:37:59Z",
    pushed_at: "2021-08-25T13:08:36Z",
    git_url: "git://github.com/AlmogWer/meal-finder.git",
    ssh_url: "git@github.com:AlmogWer/meal-finder.git",
    clone_url: "https://github.com/AlmogWer/meal-finder.git",
    svn_url: "https://github.com/AlmogWer/meal-finder",
    homepage: "https://almogwer.github.io/meal-finder/",
    size: 1378,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 406349577,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDYzNDk1Nzc=",
    name: "mega-menu",
    full_name: "AlmogWer/mega-menu",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/mega-menu",
    description: "HTML CSS & React - Mega menu",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/mega-menu",
    forks_url: "https://api.github.com/repos/AlmogWer/mega-menu/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/mega-menu/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/mega-menu/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/mega-menu/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/mega-menu/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/mega-menu/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/mega-menu/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/mega-menu/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/mega-menu/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/mega-menu/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/mega-menu/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/mega-menu/deployments",
    created_at: "2021-09-14T12:03:16Z",
    updated_at: "2021-09-14T14:16:31Z",
    pushed_at: "2021-09-14T14:16:28Z",
    git_url: "git://github.com/AlmogWer/mega-menu.git",
    ssh_url: "git@github.com:AlmogWer/mega-menu.git",
    clone_url: "https://github.com/AlmogWer/mega-menu.git",
    svn_url: "https://github.com/AlmogWer/mega-menu",
    homepage: "https://almogwer-mega-menu.netlify.app/",
    size: 767,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 401040735,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDEwNDA3MzU=",
    name: "memory-cards",
    full_name: "AlmogWer/memory-cards",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/memory-cards",
    description:
      "HTML CSS & JS - learning cards with rotating CSS animations and slide right/left effects.",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/memory-cards",
    forks_url: "https://api.github.com/repos/AlmogWer/memory-cards/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/memory-cards/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/memory-cards/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/memory-cards/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/memory-cards/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/memory-cards/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/memory-cards/deployments",
    created_at: "2021-08-29T12:51:19Z",
    updated_at: "2021-09-01T06:39:50Z",
    pushed_at: "2021-08-29T14:45:29Z",
    git_url: "git://github.com/AlmogWer/memory-cards.git",
    ssh_url: "git@github.com:AlmogWer/memory-cards.git",
    clone_url: "https://github.com/AlmogWer/memory-cards.git",
    svn_url: "https://github.com/AlmogWer/memory-cards",
    homepage: "https://almogwer.github.io/memory-cards/",
    size: 54,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 399729475,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTk3Mjk0NzU=",
    name: "menu-slider-modal",
    full_name: "AlmogWer/menu-slider-modal",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/menu-slider-modal",
    description: "HTML CSS & JS - Simple landing page -Modal and Slider",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/menu-slider-modal",
    forks_url: "https://api.github.com/repos/AlmogWer/menu-slider-modal/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/menu-slider-modal/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/menu-slider-modal/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/menu-slider-modal/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/menu-slider-modal/deployments",
    created_at: "2021-08-25T07:29:28Z",
    updated_at: "2021-09-01T06:37:43Z",
    pushed_at: "2021-08-25T08:55:00Z",
    git_url: "git://github.com/AlmogWer/menu-slider-modal.git",
    ssh_url: "git@github.com:AlmogWer/menu-slider-modal.git",
    clone_url: "https://github.com/AlmogWer/menu-slider-modal.git",
    svn_url: "https://github.com/AlmogWer/menu-slider-modal",
    homepage: "https://almogwer.github.io/menu-slider-modal/",
    size: 217,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 407484492,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDc0ODQ0OTI=",
    name: "movie-db",
    full_name: "AlmogWer/movie-db",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/movie-db",
    description:
      "HTML CSS & React - Search movies (fetch from API) with single movie routes",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/movie-db",
    forks_url: "https://api.github.com/repos/AlmogWer/movie-db/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/movie-db/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/movie-db/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/movie-db/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/movie-db/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/movie-db/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/movie-db/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/movie-db/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/movie-db/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/movie-db/tags",
    blobs_url: "https://api.github.com/repos/AlmogWer/movie-db/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/movie-db/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/movie-db/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/AlmogWer/movie-db/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/movie-db/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/movie-db/languages",
    stargazers_url: "https://api.github.com/repos/AlmogWer/movie-db/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/movie-db/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/movie-db/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/movie-db/subscription",
    commits_url: "https://api.github.com/repos/AlmogWer/movie-db/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/movie-db/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/movie-db/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/movie-db/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/movie-db/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/movie-db/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/movie-db/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/movie-db/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/movie-db/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/movie-db/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/movie-db/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/movie-db/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/movie-db/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/movie-db/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/movie-db/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/movie-db/deployments",
    created_at: "2021-09-17T09:35:45Z",
    updated_at: "2021-09-17T11:02:40Z",
    pushed_at: "2021-09-17T11:02:37Z",
    git_url: "git://github.com/AlmogWer/movie-db.git",
    ssh_url: "git@github.com:AlmogWer/movie-db.git",
    clone_url: "https://github.com/AlmogWer/movie-db.git",
    svn_url: "https://github.com/AlmogWer/movie-db",
    homepage: "https://almogwer-moviedb.netlify.app/",
    size: 1592,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 399092020,
    node_id: "MDEwOlJlcG9zaXRvcnkzOTkwOTIwMjA=",
    name: "movie-seat-booking",
    full_name: "AlmogWer/movie-seat-booking",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/movie-seat-booking",
    description: "HTML CSS & JS - Including local storage",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/movie-seat-booking",
    forks_url: "https://api.github.com/repos/AlmogWer/movie-seat-booking/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/movie-seat-booking/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/movie-seat-booking/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/movie-seat-booking/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/movie-seat-booking/deployments",
    created_at: "2021-08-23T12:15:54Z",
    updated_at: "2021-09-01T06:35:50Z",
    pushed_at: "2021-08-23T14:09:57Z",
    git_url: "git://github.com/AlmogWer/movie-seat-booking.git",
    ssh_url: "git@github.com:AlmogWer/movie-seat-booking.git",
    clone_url: "https://github.com/AlmogWer/movie-seat-booking.git",
    svn_url: "https://github.com/AlmogWer/movie-seat-booking",
    homepage: "https://almogwer.github.io/movie-seat-booking/",
    size: 14,
    stargazers_count: 0,
    watchers_count: 0,
    language: "HTML",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 405989130,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDU5ODkxMzA=",
    name: "nav-bar",
    full_name: "AlmogWer/nav-bar",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/nav-bar",
    description: "HTML CSS & React - Responsive Navbar with dynamic links",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/nav-bar",
    forks_url: "https://api.github.com/repos/AlmogWer/nav-bar/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/nav-bar/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/nav-bar/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/nav-bar/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/nav-bar/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/nav-bar/tags",
    blobs_url: "https://api.github.com/repos/AlmogWer/nav-bar/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/AlmogWer/nav-bar/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/nav-bar/languages",
    stargazers_url: "https://api.github.com/repos/AlmogWer/nav-bar/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/subscription",
    commits_url: "https://api.github.com/repos/AlmogWer/nav-bar/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/nav-bar/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/nav-bar/downloads",
    issues_url: "https://api.github.com/repos/AlmogWer/nav-bar/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/nav-bar/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/nav-bar/labels{/name}",
    releases_url: "https://api.github.com/repos/AlmogWer/nav-bar/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/nav-bar/deployments",
    created_at: "2021-09-13T13:40:45Z",
    updated_at: "2021-09-13T15:09:48Z",
    pushed_at: "2021-09-13T15:09:45Z",
    git_url: "git://github.com/AlmogWer/nav-bar.git",
    ssh_url: "git@github.com:AlmogWer/nav-bar.git",
    clone_url: "https://github.com/AlmogWer/nav-bar.git",
    svn_url: "https://github.com/AlmogWer/nav-bar",
    homepage: "https://almogwer-navbar.netlify.app/",
    size: 250,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 401348020,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDEzNDgwMjA=",
    name: "new-year-countdown",
    full_name: "AlmogWer/new-year-countdown",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/new-year-countdown",
    description:
      "HTML CSS & JS - simple landing page counting down the time until next year",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/new-year-countdown",
    forks_url: "https://api.github.com/repos/AlmogWer/new-year-countdown/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/new-year-countdown/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/new-year-countdown/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/new-year-countdown/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/new-year-countdown/deployments",
    created_at: "2021-08-30T13:09:59Z",
    updated_at: "2021-09-01T06:40:24Z",
    pushed_at: "2021-08-30T13:36:36Z",
    git_url: "git://github.com/AlmogWer/new-year-countdown.git",
    ssh_url: "git@github.com:AlmogWer/new-year-countdown.git",
    clone_url: "https://github.com/AlmogWer/new-year-countdown.git",
    svn_url: "https://github.com/AlmogWer/new-year-countdown",
    homepage: "https://almogwer.github.io/new-year-countdown/",
    size: 425,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 407076249,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDcwNzYyNDk=",
    name: "pagination",
    full_name: "AlmogWer/pagination",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/pagination",
    description: "HTML CSS & React - Pagination component",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/pagination",
    forks_url: "https://api.github.com/repos/AlmogWer/pagination/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/pagination/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/pagination/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/pagination/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/pagination/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/pagination/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/pagination/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/pagination/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/pagination/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/pagination/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/pagination/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/pagination/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/pagination/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/pagination/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/pagination/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/pagination/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/pagination/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/pagination/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/pagination/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/pagination/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/pagination/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/pagination/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/pagination/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/pagination/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/pagination/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/pagination/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/pagination/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/pagination/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/pagination/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/pagination/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/pagination/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/pagination/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/pagination/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/pagination/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/pagination/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/pagination/deployments",
    created_at: "2021-09-16T08:00:25Z",
    updated_at: "2021-09-18T11:15:14Z",
    pushed_at: "2021-09-16T12:09:42Z",
    git_url: "git://github.com/AlmogWer/pagination.git",
    ssh_url: "git@github.com:AlmogWer/pagination.git",
    clone_url: "https://github.com/AlmogWer/pagination.git",
    svn_url: "https://github.com/AlmogWer/pagination",
    homepage: "https://almogwer-pagination.netlify.app/",
    size: 627,
    stargazers_count: 1,
    watchers_count: 1,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 1,
    open_issues: 0,
    watchers: 1,
    default_branch: "main",
  },
  {
    id: 408071544,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDgwNzE1NDQ=",
    name: "quiz",
    full_name: "AlmogWer/quiz",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/quiz",
    description:
      "HTML CSS & React - Quiz fetched from API based on set-up form",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/quiz",
    forks_url: "https://api.github.com/repos/AlmogWer/quiz/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/quiz/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/quiz/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/quiz/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/quiz/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/quiz/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/quiz/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/quiz/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/quiz/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/quiz/tags",
    blobs_url: "https://api.github.com/repos/AlmogWer/quiz/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/AlmogWer/quiz/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/AlmogWer/quiz/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/AlmogWer/quiz/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/AlmogWer/quiz/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/quiz/languages",
    stargazers_url: "https://api.github.com/repos/AlmogWer/quiz/stargazers",
    contributors_url: "https://api.github.com/repos/AlmogWer/quiz/contributors",
    subscribers_url: "https://api.github.com/repos/AlmogWer/quiz/subscribers",
    subscription_url: "https://api.github.com/repos/AlmogWer/quiz/subscription",
    commits_url: "https://api.github.com/repos/AlmogWer/quiz/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/quiz/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/quiz/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/quiz/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/AlmogWer/quiz/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/quiz/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/quiz/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/quiz/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/quiz/downloads",
    issues_url: "https://api.github.com/repos/AlmogWer/quiz/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/quiz/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/quiz/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/quiz/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/quiz/labels{/name}",
    releases_url: "https://api.github.com/repos/AlmogWer/quiz/releases{/id}",
    deployments_url: "https://api.github.com/repos/AlmogWer/quiz/deployments",
    created_at: "2021-09-19T08:22:55Z",
    updated_at: "2021-09-19T12:53:05Z",
    pushed_at: "2021-09-19T12:53:02Z",
    git_url: "git://github.com/AlmogWer/quiz.git",
    ssh_url: "git@github.com:AlmogWer/quiz.git",
    clone_url: "https://github.com/AlmogWer/quiz.git",
    svn_url: "https://github.com/AlmogWer/quiz",
    homepage: "https://almogwer-quiz.netlify.app/",
    size: 431,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 1,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 1,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 406853642,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDY4NTM2NDI=",
    name: "random-person",
    full_name: "AlmogWer/random-person",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/random-person",
    description: "HTML CSS & React - Random person generator component (fetch)",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/random-person",
    forks_url: "https://api.github.com/repos/AlmogWer/random-person/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/random-person/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/random-person/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/random-person/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/random-person/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/random-person/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/random-person/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/random-person/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/random-person/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/random-person/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/random-person/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/random-person/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/random-person/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/random-person/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/random-person/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/random-person/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/random-person/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/random-person/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/random-person/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/random-person/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/random-person/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/random-person/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/random-person/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/random-person/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/random-person/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/random-person/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/random-person/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/random-person/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/random-person/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/random-person/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/random-person/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/random-person/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/random-person/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/random-person/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/random-person/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/random-person/deployments",
    created_at: "2021-09-15T16:52:21Z",
    updated_at: "2021-09-16T07:35:08Z",
    pushed_at: "2021-09-16T07:35:05Z",
    git_url: "git://github.com/AlmogWer/random-person.git",
    ssh_url: "git@github.com:AlmogWer/random-person.git",
    clone_url: "https://github.com/AlmogWer/random-person.git",
    svn_url: "https://github.com/AlmogWer/random-person",
    homepage: "https://almogwer-random-person-generator.netlify.app/",
    size: 410,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 401288502,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDEyODg1MDI=",
    name: "relaxer-app",
    full_name: "AlmogWer/relaxer-app",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/relaxer-app",
    description:
      "HTML CSS & JS - Breathing app that visually show you how to toggle your breath",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/relaxer-app",
    forks_url: "https://api.github.com/repos/AlmogWer/relaxer-app/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/relaxer-app/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/relaxer-app/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/relaxer-app/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/relaxer-app/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/relaxer-app/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/relaxer-app/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/relaxer-app/deployments",
    created_at: "2021-08-30T09:33:28Z",
    updated_at: "2021-09-01T06:40:06Z",
    pushed_at: "2021-08-30T11:29:06Z",
    git_url: "git://github.com/AlmogWer/relaxer-app.git",
    ssh_url: "git@github.com:AlmogWer/relaxer-app.git",
    clone_url: "https://github.com/AlmogWer/relaxer-app.git",
    svn_url: "https://github.com/AlmogWer/relaxer-app",
    homepage: "https://almogwer.github.io/relaxer-app/",
    size: 43,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 404753734,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDQ3NTM3MzQ=",
    name: "restaurant-menu",
    full_name: "AlmogWer/restaurant-menu",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/restaurant-menu",
    description:
      "HTML CSS & React - Restaurant menu component with dynamic buttons",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/restaurant-menu",
    forks_url: "https://api.github.com/repos/AlmogWer/restaurant-menu/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/restaurant-menu/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/restaurant-menu/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/restaurant-menu/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/restaurant-menu/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/restaurant-menu/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/restaurant-menu/deployments",
    created_at: "2021-09-09T14:27:45Z",
    updated_at: "2021-09-09T15:11:18Z",
    pushed_at: "2021-09-09T15:11:16Z",
    git_url: "git://github.com/AlmogWer/restaurant-menu.git",
    ssh_url: "git@github.com:AlmogWer/restaurant-menu.git",
    clone_url: "https://github.com/AlmogWer/restaurant-menu.git",
    svn_url: "https://github.com/AlmogWer/restaurant-menu",
    homepage: "https://almogwer-restaurant-menu.netlify.app/",
    size: 1579,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 404701013,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDQ3MDEwMTM=",
    name: "reviews",
    full_name: "AlmogWer/reviews",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/reviews",
    description:
      "HTML CSS & React - Reviews component - slide with random button",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/reviews",
    forks_url: "https://api.github.com/repos/AlmogWer/reviews/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/reviews/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/reviews/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/reviews/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/reviews/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/reviews/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/reviews/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/reviews/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/reviews/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/reviews/tags",
    blobs_url: "https://api.github.com/repos/AlmogWer/reviews/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/reviews/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/reviews/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/AlmogWer/reviews/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/reviews/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/reviews/languages",
    stargazers_url: "https://api.github.com/repos/AlmogWer/reviews/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/reviews/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/reviews/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/reviews/subscription",
    commits_url: "https://api.github.com/repos/AlmogWer/reviews/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/reviews/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/reviews/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/reviews/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/reviews/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/reviews/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/reviews/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/reviews/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/reviews/downloads",
    issues_url: "https://api.github.com/repos/AlmogWer/reviews/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/reviews/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/reviews/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/reviews/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/reviews/labels{/name}",
    releases_url: "https://api.github.com/repos/AlmogWer/reviews/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/reviews/deployments",
    created_at: "2021-09-09T11:46:40Z",
    updated_at: "2021-09-09T13:06:13Z",
    pushed_at: "2021-09-09T13:06:11Z",
    git_url: "git://github.com/AlmogWer/reviews.git",
    ssh_url: "git@github.com:AlmogWer/reviews.git",
    clone_url: "https://github.com/AlmogWer/reviews.git",
    svn_url: "https://github.com/AlmogWer/reviews",
    homepage: "https://almogwer-reviews.netlify.app/",
    size: 284,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 406284987,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDYyODQ5ODc=",
    name: "sidebar-modal",
    full_name: "AlmogWer/sidebar-modal",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/sidebar-modal",
    description: "HTML CSS & React - Sidebar and Modal components",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/sidebar-modal",
    forks_url: "https://api.github.com/repos/AlmogWer/sidebar-modal/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/sidebar-modal/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/sidebar-modal/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/sidebar-modal/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/sidebar-modal/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/sidebar-modal/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/sidebar-modal/deployments",
    created_at: "2021-09-14T08:25:24Z",
    updated_at: "2021-09-18T18:36:16Z",
    pushed_at: "2021-09-14T11:31:49Z",
    git_url: "git://github.com/AlmogWer/sidebar-modal.git",
    ssh_url: "git@github.com:AlmogWer/sidebar-modal.git",
    clone_url: "https://github.com/AlmogWer/sidebar-modal.git",
    svn_url: "https://github.com/AlmogWer/sidebar-modal",
    homepage: "https://almogwer-sidebar-modal.netlify.app/",
    size: 227,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 405609314,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDU2MDkzMTQ=",
    name: "slider",
    full_name: "AlmogWer/slider",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/slider",
    description: 'HTML CSS & React - Slider component with "auto-play"',
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/slider",
    forks_url: "https://api.github.com/repos/AlmogWer/slider/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/slider/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/slider/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/slider/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/slider/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/slider/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/slider/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/slider/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/slider/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/slider/tags",
    blobs_url: "https://api.github.com/repos/AlmogWer/slider/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/AlmogWer/slider/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/AlmogWer/slider/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/AlmogWer/slider/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/AlmogWer/slider/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/slider/languages",
    stargazers_url: "https://api.github.com/repos/AlmogWer/slider/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/slider/contributors",
    subscribers_url: "https://api.github.com/repos/AlmogWer/slider/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/slider/subscription",
    commits_url: "https://api.github.com/repos/AlmogWer/slider/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/slider/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/slider/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/slider/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/slider/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/slider/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/slider/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/slider/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/slider/downloads",
    issues_url: "https://api.github.com/repos/AlmogWer/slider/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/slider/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/slider/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/slider/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/slider/labels{/name}",
    releases_url: "https://api.github.com/repos/AlmogWer/slider/releases{/id}",
    deployments_url: "https://api.github.com/repos/AlmogWer/slider/deployments",
    created_at: "2021-09-12T10:18:27Z",
    updated_at: "2021-09-12T11:30:42Z",
    pushed_at: "2021-09-12T11:30:39Z",
    git_url: "git://github.com/AlmogWer/slider.git",
    ssh_url: "git@github.com:AlmogWer/slider.git",
    clone_url: "https://github.com/AlmogWer/slider.git",
    svn_url: "https://github.com/AlmogWer/slider",
    homepage: "https://almogwer-slider.netlify.app/",
    size: 293,
    stargazers_count: 0,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 401611926,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDE2MTE5MjY=",
    name: "sortable-list",
    full_name: "AlmogWer/sortable-list",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/sortable-list",
    description:
      "HTML CSS & JS - sortable list with drag & drop functionality - receiving a scrambled list and checking the order",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/sortable-list",
    forks_url: "https://api.github.com/repos/AlmogWer/sortable-list/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/sortable-list/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/sortable-list/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/sortable-list/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/sortable-list/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/sortable-list/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/sortable-list/deployments",
    created_at: "2021-08-31T07:26:48Z",
    updated_at: "2021-09-01T06:40:50Z",
    pushed_at: "2021-08-31T08:47:39Z",
    git_url: "git://github.com/AlmogWer/sortable-list.git",
    ssh_url: "git@github.com:AlmogWer/sortable-list.git",
    clone_url: "https://github.com/AlmogWer/sortable-list.git",
    svn_url: "https://github.com/AlmogWer/sortable-list",
    homepage: "https://almogwer.github.io/sortable-list/",
    size: 77,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 3,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 3,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 401641239,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDE2NDEyMzk=",
    name: "speak-number-guess",
    full_name: "AlmogWer/speak-number-guess",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/speak-number-guess",
    description:
      "HTML CSS & JS - speak a number to guess the number using voice recognition API",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/speak-number-guess",
    forks_url: "https://api.github.com/repos/AlmogWer/speak-number-guess/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/speak-number-guess/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/speak-number-guess/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/speak-number-guess/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/speak-number-guess/deployments",
    created_at: "2021-08-31T09:12:43Z",
    updated_at: "2021-09-01T06:41:13Z",
    pushed_at: "2021-08-31T11:11:58Z",
    git_url: "git://github.com/AlmogWer/speak-number-guess.git",
    ssh_url: "git@github.com:AlmogWer/speak-number-guess.git",
    clone_url: "https://github.com/AlmogWer/speak-number-guess.git",
    svn_url: "https://github.com/AlmogWer/speak-number-guess",
    homepage: "https://almogwer.github.io/speak-number-guess/",
    size: 71,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 401027974,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDEwMjc5NzQ=",
    name: "speech-text-reader",
    full_name: "AlmogWer/speech-text-reader",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/speech-text-reader",
    description:
      "HTML CSS & JS - Text reader with predefined toggle and custom text reader based on speech API",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/speech-text-reader",
    forks_url: "https://api.github.com/repos/AlmogWer/speech-text-reader/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/speech-text-reader/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/speech-text-reader/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/speech-text-reader/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/speech-text-reader/deployments",
    created_at: "2021-08-29T11:47:15Z",
    updated_at: "2021-09-01T06:39:27Z",
    pushed_at: "2021-08-29T12:23:59Z",
    git_url: "git://github.com/AlmogWer/speech-text-reader.git",
    ssh_url: "git@github.com:AlmogWer/speech-text-reader.git",
    clone_url: "https://github.com/AlmogWer/speech-text-reader.git",
    svn_url: "https://github.com/AlmogWer/speech-text-reader",
    homepage: "https://almogwer.github.io/speech-text-reader/",
    size: 1180,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 400475648,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDA0NzU2NDg=",
    name: "speed-typing-game",
    full_name: "AlmogWer/speed-typing-game",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/speed-typing-game",
    description: "HTML CSS & JS - speed typing game ",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/speed-typing-game",
    forks_url: "https://api.github.com/repos/AlmogWer/speed-typing-game/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/speed-typing-game/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/speed-typing-game/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/issues/events{/number}",
    events_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/speed-typing-game/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/compare/{base}...{head}",
    merges_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/speed-typing-game/deployments",
    created_at: "2021-08-27T10:43:14Z",
    updated_at: "2021-08-27T12:07:00Z",
    pushed_at: "2021-08-27T12:06:57Z",
    git_url: "git://github.com/AlmogWer/speed-typing-game.git",
    ssh_url: "git@github.com:AlmogWer/speed-typing-game.git",
    clone_url: "https://github.com/AlmogWer/speed-typing-game.git",
    svn_url: "https://github.com/AlmogWer/speed-typing-game",
    homepage: "https://almogwer.github.io/speed-typing-game/",
    size: 69,
    stargazers_count: 0,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 407158933,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDcxNTg5MzM=",
    name: "stock-photos",
    full_name: "AlmogWer/stock-photos",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/stock-photos",
    description: "HTML CSS & React - Stock photos w/ search - Infinite scroll",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/stock-photos",
    forks_url: "https://api.github.com/repos/AlmogWer/stock-photos/forks",
    keys_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/stock-photos/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/stock-photos/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/stock-photos/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/stock-photos/tags",
    blobs_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/git/blobs{/sha}",
    git_tags_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/git/tags{/sha}",
    git_refs_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/git/refs{/sha}",
    trees_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/git/trees{/sha}",
    statuses_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/statuses/{sha}",
    languages_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/languages",
    stargazers_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/contributors",
    subscribers_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/subscription",
    commits_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/stock-photos/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/{archive_format}{/ref}",
    downloads_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/downloads",
    issues_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/issues{/number}",
    pulls_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/notifications{?since,all,participating}",
    labels_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/labels{/name}",
    releases_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/releases{/id}",
    deployments_url:
      "https://api.github.com/repos/AlmogWer/stock-photos/deployments",
    created_at: "2021-09-16T12:37:26Z",
    updated_at: "2021-09-16T14:25:02Z",
    pushed_at: "2021-09-16T14:24:59Z",
    git_url: "git://github.com/AlmogWer/stock-photos.git",
    ssh_url: "git@github.com:AlmogWer/stock-photos.git",
    clone_url: "https://github.com/AlmogWer/stock-photos.git",
    svn_url: "https://github.com/AlmogWer/stock-photos",
    homepage: "https://almogwer-stock-photos.netlify.app/",
    size: 1210,
    stargazers_count: 4,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "main",
  },
  {
    id: 404779617,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDQ3Nzk2MTc=",
    name: "tabs",
    full_name: "AlmogWer/tabs",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/tabs",
    description: "HTML CSS & React- Tabs component",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/tabs",
    forks_url: "https://api.github.com/repos/AlmogWer/tabs/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/tabs/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/tabs/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/tabs/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/tabs/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/tabs/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/tabs/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/tabs/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/tabs/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/tabs/tags",
    blobs_url: "https://api.github.com/repos/AlmogWer/tabs/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/AlmogWer/tabs/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/AlmogWer/tabs/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/AlmogWer/tabs/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/AlmogWer/tabs/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/tabs/languages",
    stargazers_url: "https://api.github.com/repos/AlmogWer/tabs/stargazers",
    contributors_url: "https://api.github.com/repos/AlmogWer/tabs/contributors",
    subscribers_url: "https://api.github.com/repos/AlmogWer/tabs/subscribers",
    subscription_url: "https://api.github.com/repos/AlmogWer/tabs/subscription",
    commits_url: "https://api.github.com/repos/AlmogWer/tabs/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/tabs/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/tabs/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/tabs/issues/comments{/number}",
    contents_url: "https://api.github.com/repos/AlmogWer/tabs/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/tabs/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/tabs/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/tabs/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/tabs/downloads",
    issues_url: "https://api.github.com/repos/AlmogWer/tabs/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/tabs/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/tabs/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/tabs/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/tabs/labels{/name}",
    releases_url: "https://api.github.com/repos/AlmogWer/tabs/releases{/id}",
    deployments_url: "https://api.github.com/repos/AlmogWer/tabs/deployments",
    created_at: "2021-09-09T15:42:30Z",
    updated_at: "2021-09-12T08:39:03Z",
    pushed_at: "2021-09-12T08:39:00Z",
    git_url: "git://github.com/AlmogWer/tabs.git",
    ssh_url: "git@github.com:AlmogWer/tabs.git",
    clone_url: "https://github.com/AlmogWer/tabs.git",
    svn_url: "https://github.com/AlmogWer/tabs",
    homepage: "https://almogwer-tabs.netlify.app/",
    size: 258,
    stargazers_count: 7,
    watchers_count: 0,
    language: "CSS",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
  {
    id: 404663314,
    node_id: "MDEwOlJlcG9zaXRvcnk0MDQ2NjMzMTQ=",
    name: "tours",
    full_name: "AlmogWer/tours",
    private: false,
    owner: {
      login: "AlmogWer",
      id: 87434394,
      node_id: "MDQ6VXNlcjg3NDM0Mzk0",
      avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
      gravatar_id: "",
      url: "https://api.github.com/users/AlmogWer",
      html_url: "https://github.com/AlmogWer",
      followers_url: "https://api.github.com/users/AlmogWer/followers",
      following_url:
        "https://api.github.com/users/AlmogWer/following{/other_user}",
      gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
      starred_url:
        "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
      subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
      organizations_url: "https://api.github.com/users/AlmogWer/orgs",
      repos_url: "https://api.github.com/users/AlmogWer/repos",
      events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
      received_events_url:
        "https://api.github.com/users/AlmogWer/received_events",
      type: "User",
      site_admin: false,
    },
    html_url: "https://github.com/AlmogWer/tours",
    description:
      "HTML CSS & React - Fetch list of tours and preview them in a list with a few functionalities ",
    fork: false,
    url: "https://api.github.com/repos/AlmogWer/tours",
    forks_url: "https://api.github.com/repos/AlmogWer/tours/forks",
    keys_url: "https://api.github.com/repos/AlmogWer/tours/keys{/key_id}",
    collaborators_url:
      "https://api.github.com/repos/AlmogWer/tours/collaborators{/collaborator}",
    teams_url: "https://api.github.com/repos/AlmogWer/tours/teams",
    hooks_url: "https://api.github.com/repos/AlmogWer/tours/hooks",
    issue_events_url:
      "https://api.github.com/repos/AlmogWer/tours/issues/events{/number}",
    events_url: "https://api.github.com/repos/AlmogWer/tours/events",
    assignees_url:
      "https://api.github.com/repos/AlmogWer/tours/assignees{/user}",
    branches_url:
      "https://api.github.com/repos/AlmogWer/tours/branches{/branch}",
    tags_url: "https://api.github.com/repos/AlmogWer/tours/tags",
    blobs_url: "https://api.github.com/repos/AlmogWer/tours/git/blobs{/sha}",
    git_tags_url: "https://api.github.com/repos/AlmogWer/tours/git/tags{/sha}",
    git_refs_url: "https://api.github.com/repos/AlmogWer/tours/git/refs{/sha}",
    trees_url: "https://api.github.com/repos/AlmogWer/tours/git/trees{/sha}",
    statuses_url: "https://api.github.com/repos/AlmogWer/tours/statuses/{sha}",
    languages_url: "https://api.github.com/repos/AlmogWer/tours/languages",
    stargazers_url: "https://api.github.com/repos/AlmogWer/tours/stargazers",
    contributors_url:
      "https://api.github.com/repos/AlmogWer/tours/contributors",
    subscribers_url: "https://api.github.com/repos/AlmogWer/tours/subscribers",
    subscription_url:
      "https://api.github.com/repos/AlmogWer/tours/subscription",
    commits_url: "https://api.github.com/repos/AlmogWer/tours/commits{/sha}",
    git_commits_url:
      "https://api.github.com/repos/AlmogWer/tours/git/commits{/sha}",
    comments_url:
      "https://api.github.com/repos/AlmogWer/tours/comments{/number}",
    issue_comment_url:
      "https://api.github.com/repos/AlmogWer/tours/issues/comments{/number}",
    contents_url:
      "https://api.github.com/repos/AlmogWer/tours/contents/{+path}",
    compare_url:
      "https://api.github.com/repos/AlmogWer/tours/compare/{base}...{head}",
    merges_url: "https://api.github.com/repos/AlmogWer/tours/merges",
    archive_url:
      "https://api.github.com/repos/AlmogWer/tours/{archive_format}{/ref}",
    downloads_url: "https://api.github.com/repos/AlmogWer/tours/downloads",
    issues_url: "https://api.github.com/repos/AlmogWer/tours/issues{/number}",
    pulls_url: "https://api.github.com/repos/AlmogWer/tours/pulls{/number}",
    milestones_url:
      "https://api.github.com/repos/AlmogWer/tours/milestones{/number}",
    notifications_url:
      "https://api.github.com/repos/AlmogWer/tours/notifications{?since,all,participating}",
    labels_url: "https://api.github.com/repos/AlmogWer/tours/labels{/name}",
    releases_url: "https://api.github.com/repos/AlmogWer/tours/releases{/id}",
    deployments_url: "https://api.github.com/repos/AlmogWer/tours/deployments",
    created_at: "2021-09-09T09:33:26Z",
    updated_at: "2021-09-09T11:33:15Z",
    pushed_at: "2021-09-09T11:31:08Z",
    git_url: "git://github.com/AlmogWer/tours.git",
    ssh_url: "git@github.com:AlmogWer/tours.git",
    clone_url: "https://github.com/AlmogWer/tours.git",
    svn_url: "https://github.com/AlmogWer/tours",
    homepage: "https://almogwer-tours.netlify.app/",
    size: 1033,
    stargazers_count: 12,
    watchers_count: 0,
    language: "JavaScript",
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: "master",
  },
];
